import { StackSchemaProps } from '../../components/StackSchema/StackSchema';
import { format, parseISO } from 'date-fns';
import { ContentfulGenericPage, EntryType } from '@jbhi-fi/apis/src/contentful/types';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';

export const contentfulApiGenericPageToStackSchema = (entry: ContentfulGenericPage): StackSchemaProps | null => {
  const { fields, sys } = entry;
  if (!fields) return null;

  return {
    entryType: EntryType.genericPage,
    heading: fields.heading,
    headline: fields.seoPageTitle || fields.heading,
    parentPage: fields.parentPage?.fields?.heading ?? '',
    description: fields.seoPageDescription || documentToPlainTextString(fields.mainBody),
    thumbnailUrl: '',
    thumbnailHeight: '',
    thumbnailWidth: '',
    datePublished: format(parseISO(sys.createdAt), 'd MMM yy'),
  };
};
